<template>
  <div>
    <sui-sidebar-pushable class="authpage_wrapper">
      <sui-sidebar
        :visible="_menuVisible"
        animation="push"
        class="vertical inverted menu"
      >
        <sui-menu-header class="item">
          <h3 is="sui-header" class="teal inverted top_header">
            <logo class="logo" />
            <sui-header-content>
              Handy
              <sui-header-subheader> v.{{ appVersion }} </sui-header-subheader>
            </sui-header-content>
          </h3>
        </sui-menu-header>
        <nuxt-link @click.native="handleToggleMenu" to="/pazienti" class="item">
          <mdi-icon name="account-group" color="orange" />
          Anagrafica Pazienti
        </nuxt-link>
        <nuxt-link @click.native="handleToggleMenu" to="/backup" class="item">
          <mdi-icon name="cloud-download" color="orange" />
          Backup Dati
        </nuxt-link>
        <nuxt-link @click.native="handleToggleMenu" to="/logout" class="item">
          <mdi-icon name="account-arrow-right" color="orange" />
          Esci
        </nuxt-link>
      </sui-sidebar>
      <sui-sidebar-pusher
        :dimmed="_dimmed"
        @click.native="handleUndimmed"
        class="authpage_pusher"
      >
        <sui-menu fixed="top" fluid secondary pointing>
          <sui-menu-item
            @click.prevent="handleToggleMenu"
            class="authpage_bars"
          >
            <mdi-icon name="menu" />
          </sui-menu-item>
          <sui-menu-item>{{ title }}</sui-menu-item>
          <sui-menu-menu class="right">
            <sui-dropdown item class="icon">
              <mdi-icon name="account-circle" color="grey" />
              <sui-dropdown-menu style="marginTop: 0">
                <sui-dropdown-item @click="handleLinkProfile">
                  <mdi-icon name="account-badge-horizontal-outline" />
                  <a>Profilo</a>
                </sui-dropdown-item>
              </sui-dropdown-menu>
            </sui-dropdown>
          </sui-menu-menu>
        </sui-menu>
        <sui-segment basic class="authpage_content">
          <nuxt />
        </sui-segment>
      </sui-sidebar-pusher>
    </sui-sidebar-pushable>
    <portal-target name="semantic-ui-vue" />
  </div>
</template>

<style scoped>
.authpage_wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: stretch;
  flex-wrap: nowrap;
  padding: 0;
}
.authpage_pusher {
  display: flex;
  flex: 1;
  margin-top: 0 !important;
  padding: 0 !important;
  transition: transform 0.5s ease, margin-left 0.5s ease !important;
}
.authpage_pusher > .ui.fixed.menu {
  background-color: #fff;
}
.authpage_content {
  overflow: auto;
  flex: 1;
  margin-top: 0 !important;
  padding-top: 54px !important;
}
.top_header {
  display: flex;
  align-items: center;
}
.top_header .logo {
  width: 50px;
  margin-right: 0.5em;
}
@media all and (min-width: 1024px) {
  .authpage_bars {
    display: none !important;
  }
  .authpage_pusher {
    transform: translate3d(0, 0, 0) !important;
    margin-left: 260px !important;
  }
}
</style>

<script>
import MdiIcon from '@/components/MdiIcon.vue'
import Logo from '@/components/Logo.vue'
import packageInfo from '@/package.json'

export default {
  components: { Logo, MdiIcon },
  data() {
    return {
      menuVisible: false,
      pageLoading: true
    }
  },
  computed: {
    _menuVisible() {
      if (this.$mq === 'desktop') return true
      return this.menuVisible
    },
    _dimmed() {
      if (this.$mq === 'desktop') return false
      return this.menuVisible
    },
    appVersion() {
      return packageInfo.version
    },
    title() {
      try {
        return this.$route.matched[0].components.default.options.head().title
      } catch (e) {
        return ''
      }
    }
  },
  methods: {
    handleToggleMenu() {
      setTimeout(() => {
        this.menuVisible = !this.menuVisible
      }, 50)
    },
    handleUndimmed() {
      if (this._dimmed) {
        this.menuVisible = false
      }
    },
    handleLinkProfile() {}
  }
}
</script>
